<template>
  <div>
    <ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>
    <div slot="title">
      <h2 class="label-black">Catalogo de Cuestionarios</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <router-link to="/SISEVA/NuevoCuestionario">
              <input type="button" class="form-control btn-custom" value="Nuevo Cuestionario" />
            </router-link>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <input type="text" class="form-control" placeholder="Buscar" v-model="nombreCuestionarioBusqueda" v-on:keyup.enter="buscarCuestionarios"/>
          </div>
          <div class="col-3">
            <select class="form-control" v-model="tipoCuestionarioAux">
              <option value="0" selected>Tipo de Cuestionario (Sin filtro)</option>
              <option value="1">Autoevaluación</option>
              <option value="2">A Igual</option>
              <option value="3">A Superior</option>
              <option value="4">A Subordinado</option>
            </select>
          </div>
          <div class="col-1"><input type="checkbox" v-model="verInactivos" /></div>
          <div class="col-2 "><span class="col-form-label label-black">Ver Inactivos</span></div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-3">
            <input type="button" class="form-control btn-primary" value="Buscar" @click="buscarCuestionarios" />
          </div>
        </div>
        <div class="row" style="margin-top:50px;">
          <div class="col-12 table-responsive">
            <table class="table table-striped table-light table-hover table-sm" id="tablaCuestionarios">
              <thead class="thead-custom">
                <tr>
                  <th>Nombre del Cuestionario</th>
                  <th>Tipo de Cuestionario</th>
                  <th>Número de Preguntas</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='cuestionario in cuestionarios'>
                  <td>{{ cuestionario.nombreCuestionario}}</td>
                  <td>{{cuestionario.tipoCuestionario}}</td>
                  <td>{{cuestionario.NumeroPreguntas}}</td>
                  <td class='d-flex justify-content-around'>
                    <i v-if='cuestionario.Activo' class='fa fa-toggle-on' @click='pedirConfirmacion(cuestionario.idFormatoCuestionario,cuestionario.nombreCuestionario,false)' title="Desactivar Cuestionario"/>
                    <i v-else class='fa fa-toggle-off' @click='pedirConfirmacion(cuestionario.idFormatoCuestionario,cuestionario.nombreCuestionario,true)' title="Activar Cuestionario"/>
                    <i class='fa fa-edit' @click='editarCuestionario(cuestionario.idFormatoCuestionario)' title="Editar Cuestionario"/>
                    <i class='fa fa-question-circle' @click='asignarPreguntas(cuestionario.idFormatoCuestionario)' title="Editar Preguntas"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import catalogos from '@/../static/js/catalogos'
  export default {
    data() {
      return {
        boton : "",
        bandera: true,
        nombreCuestionarioBusqueda: "",
        tipoCuestionario: 0,
        tipoCuestionarioAux: 0,
        verInactivos: false,
        idActivacion: 0,
        banderaActivacion: false,
        cuestionarios: []
      }
    },
    components: {
      ModalConfirmacion: catalogos.SISEVA.ModalConfirmacion
    },
    methods: {
      validarMotivo: function (event) {
        var cantidadTexto = $(event.target).val().trim().length
        console.log(cantidadTexto)
          $('#botonModalConfirmacion').attr("disabled", cantidadTexto<=0)
      },
      cambiarIcono: function () {
        var boton = this.boton;
        var bandera = this.bandera;
        this.boton = null
        this.bandera = true
        var id = boton.parentElement.parentElement.childNodes[0].innerHTML
          this.activarCuestionario(id,bandera)
          $(boton).toggleClass("fa-toggle-on");
        $(boton).toggleClass("fa-toggle-off");
      },
      pedirConfirmacion: function (id, nombre, bandera) {
        var mensaje = "¿Está seguro de " + ((bandera) ? "activar" : "desactivar") + " el cuestionario "+nombre+"?"
        var titulo = "Confirmación de " + ((bandera) ? "activación" : "desactivación")
        this.idActivacion = id
        this.banderaActivacion = bandera
        this.$refs.modalConfirmacion.mostrar(titulo, mensaje, this.activarCuestionario);
      },
      activarCuestionario: function () {
        var peticion = {
          "esPrueba": false,
          "idCuestionario": this.idActivacion,
          "bandera": this.banderaActivacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.SetActivoFormatoCuestionario, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.buscarCuestionarios();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
        this.idActivacion = 0
        this.banderaActivacion = false
      }
      , buscarCuestionarios: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        this.tipoCuestionario = (this.tipoCuestionarioAux == "0") ? null : parseInt(this.tipoCuestionarioAux)
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "nombreCuestionarioBusqueda": this.nombreCuestionarioBusqueda,
          "tipoCuestionario": this.tipoCuestionario,
          "verInactivos": this.verInactivos
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetCuestionarios, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.cuestionarios = response.data.Cuestionarios//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaCuestionarios', 10)
            })
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      editarCuestionario: function (idFormatoCuestionario) {
        this.$router.push({
          name: 'EditarCuestionario',
          params: { idFormatoCuestionario: idFormatoCuestionario }
        })
      },
      asignarPreguntas: function (idFormatoCuestionario, tipoCuestionarioId, nombreCuestionario) {
        this.$router.push({
          name: 'AsignarPreguntas',
          params: { idFormatoCuestionario: idFormatoCuestionario}
        })
        }

    }, mounted: function () {
      this.buscarCuestionarios();
    }

  }

</script>

<style scoped>
.thead-custom {
  background-color: #004746;
  color: white;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/CatalogoCuestionarios.vue